import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PersonalInfoView from '../views/PersonalInfoView.vue'
import DoneView from '../views/DoneView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
		path: '/personal-info',
		name: 'PersonalInfo',
		component: PersonalInfoView,

	},
  {
    path: '/done',
    name: 'done',
    component: DoneView
  }
]

const router = createRouter({
  history: createWebHistory('selena/participants/home/'),
  routes
})

export default router
